'use strict';

const Mn = require('backbone.marionette');
const Dialog = require('common/util/dialog');
const ToggleNav = require('common/ui/view/behavior/togglenav');
const GroupAction = require('common/domain/action/group');
const GroupPermission = require('common/domain/entity/group-permission');
const GroupSettingView = require('balus/ui/view/body/group/modal/group-setting');
const SidebarNavListView = require('common/ui/view/sidebar/nav');
const Template = require('balus/ui/template/body/group/toolbar/index.hbs');
const Logger = require('common/util/logger');
const Router = require('balus/app/router/index');
const ModalView = require('common/ui/view/modal/index');
const i18n = require('i18next');

module.exports = Mn.View.extend({
    template: Template,
    ui: {
        'editGroupButton': '.group-edit-button',
        'deleteGroupButton': '.group-delete-button'
    },
    regions: {
        nav: '.sidebar-nav'
    },
    events: {
        'click @ui.editGroupButton': 'editGroup',
        'click @ui.deleteGroupButton': 'deleteGroup'
    },
    modelEvents: {
        'change': 'render'
    },
    behaviors: [ToggleNav],
    templateContext: function() {
        const context = this.getOption('context');
        const groupRole = context.getGroupRole();
        return {
            canEditGroup: groupRole.getPermission(GroupPermission.GroupEditPermission).isPermitted(context),
            canDeleteGroup: groupRole.getPermission(GroupPermission.GroupEditPermission).isPermitted(context),
        }
    },

    onRender: function() {
        if(this._navs) {
            this.renderNav(this._navs);
        }
    },

    editGroup: function() {
        const modal = new ModalView({
            title: i18n.t('title.group.setting'),
            bodyView: new GroupSettingView({
                model: this.model
            }),
            onChildviewSave: function() {
                this.disableButtons();
                this.getOption('bodyView').setting()
                    .then(() => {
                        this.hide();
                        location.reload();
                    })
                    .catch(() => {
                        this.enableButtons();
                    })
            }
        });
        modal.show();
    },
    /**
     * Group 削除の confirmation
     */
    deleteGroup: function() {
        Dialog.confirm({
            text: i18n.t('notify.delete-confirm', {name: this.model.get('name')}),
            okCallback: () => {
                this.deleting();
            }
        });
    },
    /**
     * Groupオブジェクトの削除
     */
    deleting: function() {
        Logger.info('Group deleting ...', this.model);
        GroupAction.deleteGroup({
            group: this.model.toJSON()
        })
            .then(function() {
                Router.navigate('', {trigger: true});
            });
    },
    renderNav: function(navs) {
        this._navs = navs;
        this.showChildView('nav', new SidebarNavListView({
            collection: navs,
            horizontal: true
        }));
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/group/toolbar/index.js